import { render } from "./MenuOverlay.vue?vue&type=template&id=6d9a3270&scoped=true"
import script from "./MenuOverlay.vue?vue&type=script&lang=js"
export * from "./MenuOverlay.vue?vue&type=script&lang=js"

import "./MenuOverlay.vue?vue&type=style&index=0&id=6d9a3270&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9a3270"]])

export default __exports__